import { handleActions } from 'redux-actions';
import actions from './actions';
import { entityMetaStatic } from './defaultdescriptors';

const publicStringDataEntry = {
  array: false,
  complexType: false,
  type: 'string',
  validate: { rules: '', messages: '' },
};

const initialState = {
  descriptors: {
    ItemVariantsList: {
      data: {
        list: {
          array: true,
          complexType: true,
          name: 'list',
          type: 'Items:Variant',
          validate: { rules: '', messages: '' },
        },
      },
    },
    LocationList: {
      data: {
        locations: {
          array: true,
          complexType: true,
          name: 'locations',
          type: 'Client:EmbeddedClientLocation',
          validate: { rules: '', messages: '' },
        },
      },
    },
    DocsList: {
      data: {
        list: {
          array: true,
          complexType: true,
          name: 'list',
          type: 'Docs:Doc',
          validate: { rules: '', messages: '' },
        },
      },
    },
    'Main:PublicCreator': {
      data: {
        id: { ...publicStringDataEntry, name: 'id' },
        name: { ...publicStringDataEntry, name: 'name' },
        avatar: { ...publicStringDataEntry, name: 'avatar' },
      },
    },
    'Main:PublicOwner': {
      data: {
        id: { ...publicStringDataEntry, name: 'id' },
        company: { ...publicStringDataEntry, name: 'name' },
        firstName: { ...publicStringDataEntry, name: 'first_name' },
        lastName: { ...publicStringDataEntry, name: 'last_name' },
        street: { ...publicStringDataEntry, name: 'street' },
        houseNumber: { ...publicStringDataEntry, name: 'house_number' },
        apartmentNumber: { ...publicStringDataEntry, name: 'apartment_number' },
        zipCode: { ...publicStringDataEntry, name: 'zip_code' },
        city: { ...publicStringDataEntry, name: 'city' },
        countryName: { ...publicStringDataEntry, name: 'country_name' },
        avatar: { ...publicStringDataEntry, name: 'avatar' },
        email: { ...publicStringDataEntry, name: 'email' },
        phone: { ...publicStringDataEntry, name: 'phone' },
        fax: { ...publicStringDataEntry, name: 'fax' },
      },
    },
  },
  attributes: {},
  pending: 0,
};

Object.keys(entityMetaStatic).forEach(key => {
  initialState.descriptors[key] = entityMetaStatic[key];
});

function assignDescriptor(container, descriptor) {
  if (!container[descriptor.name] || !container[descriptor.name].data) {
    if (container[descriptor.name]) {
      container[descriptor.name] = { ...container[descriptor.name], data: descriptor.data, pending: false };
    } else {
      container[descriptor.name] = descriptor;
    }
  }
  Object.keys(descriptor.data).forEach(property => {
    const propertyDescriptor = descriptor.data[property];
    if (propertyDescriptor.complexMeta) {
      assignDescriptor(container, propertyDescriptor.complexMeta);
    }
  });
  return container;
}

const reducer = handleActions(
  {
    [actions.loadMetadata]: (state, { payload }) => {
      const { metaId } = payload;
      return {
        ...state,
        descriptors: { ...state.descriptors, [metaId]: { ...state.descriptors[metaId], pending: true } },
        pending: state.pending + 1,
      };
    },
    [actions.loadMetadataFailure]: (state, { payload }) => {
      const { metaId, error } = payload;
      return {
        ...state,
        descriptors: { ...state.descriptors, [metaId]: { pending: false, data: null, error } },
        pending: state.pending - 1,
      };
    },
    [actions.loadMetadataCancelled]: (state, { payload }) => {
      const { metaId } = payload;
      return {
        ...state,
        descriptors: { ...state.descriptors, [metaId]: { ...state.descriptors[metaId], pending: false } },
        pending: state.pending - 1,
      };
    },
    [actions.loadMetadataComplete]: (state, { payload }) => {
      return {
        ...state,
        descriptors: assignDescriptor({ ...state.descriptors }, payload),
        pending: state.pending - 1,
      };
    },
    [actions.loadAttributes]: (state, { payload }) => {
      const { category } = payload;
      return {
        ...state,
        attributes: { ...state.attributes, [category]: { ...state.attributes[category], pending: true } },
        pending: state.pending + 1,
      };
    },
    [actions.loadAttributesFailure]: (state, { payload }) => {
      const { category, error } = payload;
      return {
        ...state,
        attributes: { ...state.attributes, [category]: { pending: false, list: null, error } },
        pending: state.pending - 1,
      };
    },
    [actions.loadAttributesComplete]: (state, { payload }) => {
      const { category, list } = payload;
      return {
        ...state,
        attributes: { ...state.attributes, [category]: { ...state.attributes[category], list, pending: false } },
        pending: state.pending - 1,
      };
    },
  },
  initialState
);
export default reducer;
